export default __webpack_public_path__ + "static/media/torre-panoramica.1443200a.webp";